import { render, staticRenderFns } from "./SetWallet.vue?vue&type=template&id=2bf9f240"
import script from "./SetWallet.vue?vue&type=script&lang=ts"
export * from "./SetWallet.vue?vue&type=script&lang=ts"
import style0 from "./SetWallet.vue?vue&type=style&index=0&id=2bf9f240&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports